/**
 * bd__g-guide.js
 * Guide Page — Scroll Spy, Sticky Nav Active States, Smooth Scroll
 * Shopify Dawn Theme compatible — vanilla JS, no dependencies
 */

(function () {
  'use strict';

  // ── Entry point ──────────────────────────────────────────────────────────────
  function init() {
    var pages = document.querySelectorAll('.bd__g-page');
    if (!pages.length) return;

    pages.forEach(function (pageEl) {
      var sections       = pageEl.querySelectorAll('.bd__g-section');
      var sidebarItems   = pageEl.querySelectorAll('.bd__g-sidebar-nav__item');
      var topNavPills    = pageEl.querySelectorAll('.bd__g-top-nav__pill');

      if (!sections.length) return;

      // Build lookup: sectionId → [matching nav elements]
      var sidebarMap = buildNavMap(sidebarItems, 'data-sidebar-target');
      var topNavMap  = buildNavMap(topNavPills,   'data-nav-target');

      // ── Scroll Spy via IntersectionObserver ────────────────────────────────
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            setActiveNav(sidebarItems, sidebarMap, id);
            setActiveNav(topNavPills,  topNavMap,  id);
            scrollSidebarItemIntoView(pageEl, sidebarMap[id]);
          }
        });
      }, {
        // Fire when ~30% of section crosses the viewport centre
        rootMargin: '-15% 0px -55% 0px',
        threshold: 0
      });

      sections.forEach(function (section) {
        observer.observe(section);
      });

      // ── Smooth scroll on click ─────────────────────────────────────────────
      var allNavLinks = pageEl.querySelectorAll(
        '.bd__g-sidebar-nav__item, .bd__g-top-nav__pill'
      );

      allNavLinks.forEach(function (el) {
        el.addEventListener('click', function (e) {
          var href = el.getAttribute('href');
          if (!href || href === '#') return;
          var target = document.querySelector(href);
          if (!target) return;

          e.preventDefault();

          // Compute offset: header + top nav + small gap
          var offset = getScrollOffset();

          var targetY = target.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({ top: targetY, behavior: 'smooth' });
        });
      });
    });
  }

  // ── Helpers ──────────────────────────────────────────────────────────────────

  /**
   * Build a map: targetId → [nav elements that point to that id]
   */
  function buildNavMap(elements, attrName) {
    var map = {};
    elements.forEach(function (el) {
      var target = el.getAttribute(attrName);
      if (target) {
        if (!map[target]) map[target] = [];
        map[target].push(el);
      }
    });
    return map;
  }

  /**
   * Remove is-active from all elements in the group, add it to those
   * matching the active section id.
   */
  function setActiveNav(allItems, navMap, activeSectionId) {
    allItems.forEach(function (el) {
      el.classList.remove('is-active');
    });
    if (navMap[activeSectionId]) {
      navMap[activeSectionId].forEach(function (el) {
        el.classList.add('is-active');
      });
    }
  }

  /**
   * Keep the active sidebar item visible inside the sticky sidebar by
   * scrolling the sidebar element itself (it has overflow-y: auto).
   */
  function scrollSidebarItemIntoView(pageEl, activeItems) {
    if (!activeItems || !activeItems.length) return;
    var sidebar = pageEl.querySelector('.bd__g-sidebar');
    if (!sidebar) return;

    var activeEl = activeItems[0];
    var sidebarRect = sidebar.getBoundingClientRect();
    var itemRect    = activeEl.getBoundingClientRect();

    var relativeTop    = itemRect.top    - sidebarRect.top    + sidebar.scrollTop;
    var relativeBottom = itemRect.bottom - sidebarRect.top    + sidebar.scrollTop;

    if (relativeTop < sidebar.scrollTop) {
      sidebar.scrollTo({ top: relativeTop - 8, behavior: 'smooth' });
    } else if (relativeBottom > sidebar.scrollTop + sidebarRect.height) {
      sidebar.scrollTo({ top: relativeBottom - sidebarRect.height + 8, behavior: 'smooth' });
    }
  }

  /**
   * Calculate the total sticky offset (Dawn header + our top nav).
   */
  function getScrollOffset() {
    // Dawn exposes --header-height as a CSS variable on the root
    var headerHeightRaw = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height').trim();
    var headerHeight = headerHeightRaw ? parseFloat(headerHeightRaw) : 0;

    // Our top nav height
    var topNav = document.querySelector('.bd__g-top-nav');
    var topNavHeight = topNav ? topNav.offsetHeight : 0;

    return headerHeight + topNavHeight + 16;
  }

  // ── DOM ready ────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for Shopify theme editor live preview reloads
  document.addEventListener('shopify:section:load', function () {
    init();
  });

})();